import { Link } from 'react-router-dom';

export default function Footer() {
  const quickLinks = [
    { name: 'Hakkımızda', path: '/#hakkımızda' },
    { name: 'Projelerimiz', path: '/#projeler' },
    { name: 'Takım', path: '/takim' },
    { name: 'İletişim', path: '/iletisim' }
  ];
  const socialMedia = [
    { icon: 'ri-instagram-fill', link: '#', color: 'hover:bg-[#E4405F]' },
    { icon: 'ri-linkedin-fill', link: '#', color: 'hover:bg-[#0077B5]' },
    { icon: 'ri-youtube-fill', link: '#', color: 'hover:bg-[#FF0000]' },
    { icon: 'ri-twitter-fill', link: '#', color: 'hover:bg-[#1DA1F2]' },
    { icon: 'ri-github-fill', link: '#', color: 'hover:bg-white' }
  ];

  return (
    <footer id="iletişim" className="relative bg-[#0a0a0a] pt-20 pb-8">
      {/* Top Border Line */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#00d9ff]/30 to-transparent" />

      <div className="max-w-7xl mx-auto px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-16 mb-16">
          {/* Left Column - Logo & Social */}
          <div className="space-y-6">
            <Link to="/" className="flex items-center gap-4 cursor-pointer">
              <img
                src="https://static.readdy.ai/image/d01eec00e4772b31ebec3f16d57f9686/a135775721950a9d58bee29176af8952.jpeg"
                alt="TETRA Logo"
                className="h-12 w-12 object-contain"
              />
              <span className="text-2xl font-bold">TETRA</span>
            </Link>
            <p className="text-white/60 italic text-base">Engineering the Future</p>

            {/* Social Media Icons */}
            <div className="flex gap-4">
              {socialMedia.map((social, index) => (
                <a
                  key={index}
                  href={social.link}
                  className={`w-11 h-11 flex items-center justify-center bg-[#1a1a1a] rounded-full transition-all duration-300 ${social.color} hover:scale-110 cursor-pointer group`}
                >
                  <i className={`${social.icon} text-xl text-white group-hover:text-black`} />
                </a>
              ))}
            </div>
          </div>

          {/* Middle Column - Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-6">Keşfet</h4>
            <ul className="space-y-3">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  {link.path.includes('#') ? (
                    <a
                      href={link.path}
                      className="group text-white/70 hover:text-white transition-all duration-300 flex items-center gap-2 cursor-pointer"
                    >
                      <span className="w-0 group-hover:w-4 h-px bg-[#00d9ff] transition-all duration-300" />
                      {link.name}
                    </a>
                  ) : (
                    <Link
                      to={link.path}
                      className="group text-white/70 hover:text-white transition-all duration-300 flex items-center gap-2 cursor-pointer"
                    >
                      <span className="w-0 group-hover:w-4 h-px bg-[#00d9ff] transition-all duration-300" />
                      {link.name}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Right Column - Contact & Newsletter */}
          <div className="space-y-6">
            <h4 className="text-lg font-bold mb-6">Bize Ulaşın</h4>
            <div className="space-y-3 text-white/70">
              <a href="mailto:tetra@university.edu" className="block hover:text-[#00d9ff] transition-colors duration-300 cursor-pointer">
                <i className="ri-mail-line mr-2" />
                tetra@university.edu
              </a>
              <a href="tel:+905551234567" className="block hover:text-[#00d9ff] transition-colors duration-300 cursor-pointer">
                <i className="ri-phone-line mr-2" />
                +90 555 123 45 67
              </a>
              <p className="leading-relaxed">
                <i className="ri-map-pin-line mr-2" />
                Üniversite Kampüsü<br />
                <span className="ml-6">Mühendislik Fakültesi, İstanbul</span>
              </p>
            </div>

            {/* Newsletter Form */}
            <div className="pt-4">
              <h5 className="text-sm font-semibold mb-3 text-white/80">Bülten Aboneliği</h5>
              <div className="flex">
                <input
                  type="email"
                  placeholder="E-posta adresiniz"
                  className="flex-1 px-5 py-3 bg-[#1a1a1a] border border-[#333] rounded-l-full text-white placeholder-white/40 focus:outline-none focus:border-[#00d9ff] transition-colors duration-300"
                />
                <button className="w-12 h-12 bg-[#00d9ff] rounded-r-full flex items-center justify-center hover:bg-[#00b8d4] transition-colors duration-300 cursor-pointer group">
                  <i className="ri-arrow-right-line text-xl text-black group-hover:translate-x-1 transition-transform duration-300" />
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-white/50">
            <p>© 2025 TETRA Engineering Team. Tüm hakları saklıdır.</p>
            <div className="flex gap-6">
              <a href="#" className="hover:text-white transition-colors duration-300 cursor-pointer">
                Gizlilik Politikası
              </a>
              <span>|</span>
              <a href="#" className="hover:text-white transition-colors duration-300 cursor-pointer">
                Kullanım Koşulları
              </a>
              <span>|</span>
              <a 
                href="https://readdy.ai/?origin=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:text-[#00d9ff] transition-colors duration-300 cursor-pointer"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
